import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService, HttpMethod } from '../common/api.service';
import { Child } from './child.model';
import { ChildEditModel } from './child-edit.model';
import { MemberCountWithCategoriesResult } from '../member/member-count-with-categories-result.model';
import { ChildrenCountWithCategoriesResult } from './children-count-with-categories-result.model';

@Injectable({
    providedIn: 'root'
})
export class ChildrenApiService extends ApiService
{
    constructor(http: HttpClient)
    {
        super(http);
    }

    getChildren(): Observable<Child[]>
    {
        return this.apiRequest(this.getChildrenUrl, HttpMethod.Get)
            .pipe(map((json: any) => json.map((item: any) => new Child(item))));
    }

    getChildrenWithFaceRecognitionResults(): Observable<Child[]>
    {
        return this.apiRequest(this.getChildrenWithFaceRecognitionResultsUrl, HttpMethod.Get)
            .pipe(map((json: any) => json.map((item: any) => new Child(item))));
    }

    getChild(id: number): Observable<Child>
    {
        return this.apiRequest<any>(this.getChildUrl(id), HttpMethod.Get).pipe(map(json => new Child(json)));
    }

    getChildWithFaceRecognitionResults(id: number): Observable<Child>
    {
        return this.apiRequest<any>(this.getChildWithFaceRecognitionResultsUrl(id), HttpMethod.Get).pipe(map(json => new Child(json)));
    }

    createChild(model: ChildEditModel): Observable<Child>
    {
        return this.apiRequest<any>(this.createChildUrl, HttpMethod.Post, JSON.stringify(model)).pipe(map(json => new Child(json)));
    }

    updateChild(model: ChildEditModel): Observable<Child>
    {
        return this.apiRequest<any>(this.updateChildUrl, HttpMethod.Put, JSON.stringify(model)).pipe(map(json => new Child(json)));
    }

    deleteChildren(childrenIds: number[]): Observable<any>
    {
        return this.apiRequest<any>(this.deleteChildrenUrl, HttpMethod.Delete, JSON.stringify({ ChildrenIds: childrenIds }));
    }

    getChildrenCountForCategories(categoryIds: number[]): Observable<ChildrenCountWithCategoriesResult>
    {
        const params = { filter: categoryIds };
        return this.apiRequest<any>(this.getChildrenCountForCategoriesUrl, HttpMethod.Put, JSON.stringify(params))
            .pipe(map(json => new ChildrenCountWithCategoriesResult(json)));
    }

    addCategoriesForChildren(childrenIds: number[], categoryIds: number[])
    {
        return this.apiRequest<any>(this.addCategoriesForChildrenUrl, HttpMethod.Post, JSON.stringify({ ChildrenIds: childrenIds, CategoryIds: categoryIds }));
    }

    deleteCategoriesForChildren(childrenIds: number[], categoryIds: number[])
    {
        return this.apiRequest<any>(this.deleteCategoriesForChildrenUrl, HttpMethod.Post, JSON.stringify({ ChildrenIds: childrenIds, CategoryIds: categoryIds }));
    }


    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================
    /* tslint:disable:member-ordering */
    private get baseChildrenApiUrl(): string { return `${this.baseApiUrl}children`; }
    get getChildrenUrl(): string { return `${this.baseChildrenApiUrl}/admin`; }
    getChildUrl(id: number) { return `${this.baseChildrenApiUrl}/${id}`; }
    get getChildrenWithFaceRecognitionResultsUrl(): string { return `${this.baseChildrenApiUrl}/faceRecognitionResults`; }
    getChildWithFaceRecognitionResultsUrl(id: number) { return `${this.baseChildrenApiUrl}/faceRecognitionResults/${id}`; }
    get createChildUrl() { return `${this.baseChildrenApiUrl}`; }
    get updateChildUrl() { return `${this.baseChildrenApiUrl}`; }
    get deleteChildrenUrl() { return `${this.baseChildrenApiUrl}`; }
    get addCategoriesForChildrenUrl() { return `${this.baseChildrenApiUrl}/addCategoriesForChildren`; }
    get deleteCategoriesForChildrenUrl() { return `${this.baseChildrenApiUrl}/deleteCategoriesForChildren`; }
    get getChildrenCountForCategoriesUrl() { return `${this.baseChildrenApiUrl}/childrenCountsForCategories`; }
}
